import React, { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

import { useConfirmationDialog } from '_lib/hooks/ConfirmationDialogHook';
import { logDebug } from '_lib/utils/logging';

export const NavigationBlocker = ({ getBlockCondition }: { getBlockCondition: () => boolean }) => {
  const confirmationDialog = useConfirmationDialog();

  const dialogIsOpen = useRef(false);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    const navigationBlocked = currentLocation.pathname !== nextLocation.pathname && getBlockCondition();
    logDebug('NavigationBlocker', { currentLocation, nextLocation, navigationBlocked });
    return navigationBlocked;
  });

  useEffect(() => {
    const dialogFunction = async () => {
      dialogIsOpen.current = true;

      const result = await confirmationDialog.show({
        titleText: 'Unsaved Changes',
        contentText: 'You have unsaved changes. Are you sure you want to leave this page?'
      });

      if (result?.action === 'CONFIRM' && blocker.state === 'blocked') {
        blocker.proceed();
      } else if (blocker.state === 'blocked') {
        blocker.reset();
      }

      dialogIsOpen.current = false;
    };

    if (blocker.state === 'blocked' && !dialogIsOpen.current) {
      dialogFunction();
    }
  }, [blocker, blocker.state, confirmationDialog]);

  return <>{confirmationDialog.element}</>;
};
